<template>
  <div class="bg-white mobile-wrapper">
    <payment-indicator
      v-if="showPaymentIndicator"
      :is-pending="proccessing"
      :succeeded="paymentSucceeded"
      @hide="hidePaymentIndicator"
    ></payment-indicator>
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="navigateToShoppingCart"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="navigateToShoppingCart">
              {{ $t("message.checkout") }}
            </span>
          </div>
        </div>
      </div>
      <!-- /banner -->
    </div>
    <div class="content-padding" />
    <div
      v-show="!showBecomeMember"
      v-if="!user && viewConfig.LogIn"
      class="login-warning"
      role="alert"
      :style="mobileStyles.alertInfoBackGround"
    >
      <a
        href="#"
        :style="mobileStyles.btn"
        class="btn btn-primary pr-2"
        @click="setShowOverlay(true)"
        >{{ $t("message.login") }}</a
      >
      <span class="pl-2">
        {{ $t("message.placeAnOrderAsGuestWithoutCreatingAccount") }}
      </span>
    </div>
    <form @submit.prevent="placeOrder">
      <div class="container mt-2">
        <div class="row" v-show="!showBecomeMember">
          <div class="col-12">
            <div class="bg-white mb-2">
              <div class="d-flex justify-content-center">
                <div class="w-100">
                  <h4
                    v-show="
                      !(
                        !viewConfig.Delivery &&
                        !viewConfig.PickUp &&
                        !viewConfig.DeliverToRoom &&
                        !viewConfig.EatIn
                      )
                    "
                  >
                    {{ $t("message.gettingYourOrder") }}
                  </h4>
                  <div
                    class="btn-group flex-wrap"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      v-show="isEnableTab('delivery')"
                      :style="btnStyle(isDelivery, true)"
                      type="button"
                      class="btn"
                      @click="deliveryMode"
                    >
                      {{ $t("message.checkoutDelivery") }}
                    </button>
                    <button
                      v-if="isEnableTab('pickUp')"
                      :style="btnStyle(isPickup, true)"
                      type="button"
                      class="btn"
                      @click="pickupMode"
                    >
                      {{ $t("message.pickUp") }}
                    </button>
                    <button
                      v-if="isEnableTab('deliverToRoom')"
                      :style="btnStyle(isChargeToRoom, true)"
                      type="button"
                      class="btn"
                      @click="chargeToRoomMode"
                    >
                      {{ $t("message.deliverToRoom") }}
                    </button>
                    <button
                      v-if="isEnableTab('dineIn')"
                      :style="btnStyle(isEatIn, true)"
                      type="button"
                      class="btn"
                      @click="eatInMode"
                    >
                      {{ $t("message.dineIn") }}
                    </button>
                  </div>
                  <pickup-address
                    v-show="
                      isPickup &&
                      !pickupDisabled &&
                      !viewConfig.HideAddressOnPickup
                    "
                  />
                  <my-detail
                    v-if="!selectedCompany.ChargeToRoom && !isEatIn"
                    ref="myDetails"
                    :edit-model="detailModel"
                    :charge-to-room="selectedCompany.ChargeToRoom"
                    @save-user="saveUser"
                    :for-gift="false"
                  />
                  <delivery-address
                    v-if="isDelivery && googleLoaded"
                    ref="deliveryAddress"
                    :edit-model="deliveryAddressModel"
                    @postalCodeUpdate="updatePostalCodeHandler"
                  />
                  <div
                    v-show="!isChargeToRoom && (isDelivery || isPickup)"
                    class="form-row mt-4"
                  >
                    <div
                      class="form-group col-12"
                      v-if="
                        selectedCompany.EnablePreoderForDelivery && isDelivery
                      "
                    >
                      <label class="required" for="date-select">
                        {{ $t("message.deliveryDate") }}
                      </label>
                      <date-picker
                        @closed="setDeliveryTimes(deliveryDate, true)"
                        v-model="deliveryDate"
                        :disabledDates="deliveryDisabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div
                      class="form-group col-12"
                      v-if="selectedCompany.EnablePreoderForPickup && isPickup"
                    >
                      <label class="required" for="date-select">
                        {{ $t("message.pickupDate") }}
                      </label>
                      <date-picker
                        @closed="setPickupTimes(pickupDate, false, selectedPickupTime)"
                        v-model="pickupDate"
                        :disabledDates="pickupDisabledDates"
                        bootstrap-styling
                      ></date-picker>
                    </div>
                    <div
                      class="form-group col-12"
                      v-show="isDelivery && !isDeliveryTimeSlotsEnable"
                    >
                      <label class="required" for="time-select">{{
                        $t("message.deliveryTime")
                      }}</label>
                      <select
                        id="time-select"
                        name="deliveryTime"
                        v-model="selectedDeliveryTime"
                        @change="selectedDeliveryTimeChange"
                        class="form-control"
                      >
                        <option
                          v-for="(t, index) in dtimes"
                          :key="index"
                          :value="t.time"
                        >
                          {{ t.format }}
                        </option>
                      </select>
                      <div class="invalid-feedback">
                        {{
                          OOErrors.first("deliveryTime")
                            | inputNameLocale("deliveryTime")
                        }}
                      </div>
                    </div>
                    <div v-show="isPickup" class="form-group col-12">
                      <label
                        class="required"
                        v-show="isPickup"
                        for="time-select"
                        >{{ $t("message.pickupTime") }}</label
                      >
                      <select
                        id="time-select"
                        name="pickupTime"
                        v-model="selectedPickupTime"
                        class="form-control"
                      >
                        <option
                          v-for="(t, index) in pickupTimes"
                          :key="index"
                          :value="t.time"
                        >
                          {{ t.format }}
                        </option>
                      </select>
                      <div class="invalid-feedback">
                        {{
                          OOErrors.first("pickupTime")
                            | inputNameLocale("pickupTime")
                        }}
                      </div>
                    </div>
                  </div>
                  <label
                    v-show="isDelivery && isDeliveryTimeSlotsEnable"
                    class="required"
                    >{{ $t("message.deliveryTime") }}</label
                  >
                  <div
                    v-show="isDelivery && isDeliveryTimeSlotsEnable"
                    class="form-row"
                  >
                    <div
                      class="btn time-slot-btn"
                      style="padding: 2px"
                      v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') >= 0
                      )"
                      :key="index"
                      @click="
                        selectedDeliveryTime = timeSlot.time;
                        selectedDeliveryTimeChange();
                      "
                      :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                      :disabled="getDeliveryIsLoading"
                    >
                      <span>ASAP</span>
                      <br />
                      <span>{{
                        timeSlot.format.split("(")[1].split(")")[0]
                      }}</span>
                    </div>
                    <button
                      type="button"
                      class="btn time-slot-btn"
                      v-for="(timeSlot, index) in dtimes.filter(
                        (p) => p.format.indexOf('ASAP') < 0
                      )"
                      :key="index"
                      @click="
                        selectedDeliveryTime = timeSlot.time;
                        selectedDeliveryTimeChange();
                      "
                      :style="
                        getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                      "
                      :disabled="getDeliveryIsLoading"
                    >
                      {{ timeSlot.format }}
                    </button>
                  </div>
                  <room-delivery
                    v-if="isChargeToRoom"
                    ref="roomDelivery"
                    :edit-model="roomDeliveryModel"
                  />
                  <eat-in
                    ref="eatIn"
                    @save-user="saveUser"
                    v-if="isEatIn"
                    :edit-model="eatInModel"
                  ></eat-in>
                  <div class="form-row" v-show="viewConfig.ShowNotes">
                    <div class="form-group col-sm-12" style="margin-bottom: 0">
                      <h4>{{ $t("message.notes") }}</h4>
                      <textarea
                        id="notes"
                        maxlength="300"
                        v-model="notes"
                        name="notes"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div v-if="getSurchargeHolidayAmount > 0" class="form-row">
                    <div class="form-group col-6">
                      {{ getSurchareHolidayName }}
                    </div>
                    <div class="form-group col-6">
                      {{ getSurchargeHolidayAmount | formatMoney }}
                    </div>
                  </div>
                  <div v-if="hqDoc && hqDoc.IsSushiHub">
                    <div class="form-row">
                      <div
                        class="form-group col-sm-12 joinourmail"
                        :class="{ shake: turnAcceptLabelToRed }"
                      >
                        <input
                          type="checkbox"
                          id="acceptTerms"
                          name="acceptTerms"
                          class="acceptTerms"
                          v-model="AcceptTermsAndCondition"
                        />
                        <label :style="acceptTermsStyle()"
                          >I have read and accept the
                          <a
                            @click.prevent="showTermsAndCondition()"
                            style="cursor: pointer; text-decoration: underline"
                            >terms and conditions</a
                          >.</label
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    :class="isChargeToRoom ? 'mt-4 xxxx' : 'mt-2 xxxx'"
                    v-if="showChargeToRoom()"
                  >
                    <payment-type
                      @set-payment-method="setPaymentMethod"
                      @set-show-pay-by-apple="setCanPayByApple"
                      @set-show-pay-by-google="setCanPayByGoogle"
                      :is-pay-by-cash-enable="isPayByCashEnable"
                      :is-pay-by-point-enable="payByPoint.canPay"
                      :card-value-in-point="payByPoint.cardValueInPoint"
                      :value="paymentMethod"
                    ></payment-type>
                  </div>
                  <div v-if="(canPayByApple || canPayByGoogle) && (!viewConfig.PayLaterOnly || !isEatIn) && getTotalPrice > 0">
                    <google-pay
                      :disabled="getDeliveryIsLoading || addressOutOfService"
                      @finalize="beginStripePayment"
                      @validate="placeOrder"
                      @error="googlePaymentError"
                      @stripe-click="setMethodAndPlaceOrder"
                      @proccessing="updateProcessing"
                      ref="stripePayRef"
                    />
                  </div>
                  <div class="mt-4" v-if="canPayByPoints && (!viewConfig.PayLaterOnly || !isEatIn)">
                    <div class="form-row">
                      <div class="col-sm-12">
                        <button
                          @touchstart="
                            (event) => {
                              if (orderDisbaled || showDeliveryDistance)
                                event.preventDefault();
                            }
                          "
                          :disabled="payButtonsAreDisabled"
                          type="button"
                          @click.prevent="setMethodAndPlaceOrder(2)"
                          class="
                            btn btn-primary btn-lg btn-block
                            mb-2
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          :style="orderButtonStyles"
                        >
                          {{ $t("message.payByLoyaltyPoints") }} &nbsp;
                          <span class="payByPoint-span text-success">
                            -{{
                              Math.ceil(payByPoint.cardValueInPoint)
                                | formatNumber
                            }}
                            pts ({{ getTotalPrice | formatMoney(currencySign) }})
                          </span>
                          <span v-show="proccessing && paymentMethod === 2">
                            <i class="spin-sm ml-4" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mt-4" v-if="isPayByCashEnable && (!viewConfig.PayLaterOnly || !isEatIn)">
                    <div class="form-row">
                      <div class="col-sm-12">
                        <button
                          @touchstart="
                            (event) => {
                              if (orderDisbaled || showDeliveryDistance)
                                event.preventDefault();
                            }
                          "
                          :disabled="payButtonsAreDisabled"
                          type="button"
                          @click.prevent="setMethodAndPlaceOrder(3)"
                          class="
                            btn btn-primary btn-lg btn-block
                            mb-2
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          :style="orderButtonStyles"
                        >
                          {{ $t("message.payByCash") }} ({{
                            getTotalPrice | formatMoney(currencySign)
                          }})
                          <span v-show="proccessing && paymentMethod === 3">
                            <i class="spin-sm ml-4" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="!viewConfig.PayLaterOnly || !isEatIn">
                    <payment
                      ref="payment"
                      :can-pay-by-other-than-card="canPayByOtherThanCard"
                      :user="user"
                      :dbuser="userInfo"
                      :edit-model="paymentModel"
                      @save-credit="saveCredit"
                    />
                  </div>
                  <div v-if="!viewConfig.PayLaterOnly || !isEatIn" class="mt-4">
                    <div class="form-row">
                      <div class="col-sm-12">
                        <button
                          type="button"
                          @click.prevent="setMethodAndPlaceOrder(1)"
                          :disabled="payButtonsAreDisabled"
                          class="
                            btn btn-primary btn-lg btn-block
                            mb-2
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          :style="orderButtonStyles"
                        >
                          {{ $t("message.payByCard") }} ({{
                            getTotalPrice | formatMoney(currencySign)
                          }})
                          <span v-show="proccessing && paymentMethod == 1">
                            <i class="spin-sm ml-4" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="canPayLater" class="mt-4">
                    <div class="form-row">
                      <div class="col-sm-12">
                        <button
                          type="button"
                          @click.prevent="setMethodAndPlaceOrder(8)"
                          :disabled="payLaterButtonIsDisabled"
                          class="
                            btn btn-primary btn-lg btn-block
                            mb-2
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                          :style="orderButtonStyles"
                        >
                          {{ $t("message.payLater") }}
                          <span v-show="proccessing && paymentMethod == 8">
                            <i class="spin-sm ml-4" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="hasMarketingLicense">
                    <div class="form-row mt-4" >
                      <div class="form-group col-sm-12 joinourmail">
                        <input
                          type="checkbox"
                          id="joinourmail"
                          name="joinourmail"
                          value="joinourmail"
                          v-model="JoinOurMail"
                        />
                        <label for="joinourmail">Join our mailing list!</label>
                        <p class="label">
                          By signing up you are agreeing to receive information,
                          promotional material as well as exclusive offers.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-show="error" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong v-html="error"></strong>
                    </div>
                  </div>
                  <div v-show="addressOutOfService" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong>
                        {{
                          getDeliveryAddressMessage
                            ? getDeliveryAddressMessage
                            : $t("message.DeliveryNotAvailableToThisAddress")
                        }}
                      </strong>
                    </div>
                  </div>
                  <div v-show="!exceedMinPurchase" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong>
                        {{ $t("message.minimumPurchaseIs") }}
                        {{ minPurchase | formatMoney(currencySign) }} ({{
                          $t("message.excludingDeliveryFee")
                        }})
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="showBecomeMember">
          <div class="col-12">
            <h4>{{ $t("message.becomeMember") }}</h4>
            <p>{{ $t("message.fasterCheckoutManageOrdersEarnPoints") }}</p>
            <footer class="extras-footer">
              <button
                type="button"
                class="btn btn-cancel"
                @click="setBecomeMemberResult(false)"
              >
                {{ $t("message.skip") }}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                :style="mobileStyles.btn"
                @click="setBecomeMemberResult(true)"
              >
                <span>{{ $t("message.becomeMember") }}</span>
              </button>
            </footer>
          </div>
        </div>
      </div>
    </form>

    <modal
      ref="privacyModal"
      v-if="showPrivacyModal"
      full-header
      @close="closePrivacyPolicyModal"
    >
      <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header">
              {{ $t("message.termsAndConditions") }}
            </h2>
          </div>
          <p
            class="py-4 terms-and-conditions"
            v-html="selectedCompany.TermsAndConditions"
          ></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            :style="buttonStyles"
            @click="closePrivacyPolicyModal()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
    <shopfooter :showInFooter="false" />
     <modal
      v-if="showClearCartModal"
      ref="ClearCartModal"
      full-header
      @close="closeClearCartModal"
    >
      <template slot="body">
        <div class="container">
          <p class="py-4">{{ $t("message.clearCartMessage", {OrderType : getSelectedOrderTypeName}) }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100 d-flex gap-20 justify-content-center" style="z-index: 2;">
          <button
            class="privacy-btn mr-3"
            data-dismiss="modal"
            type="button"
            @click="cancelClearCart()"
          >
            {{ $t("message.cancel") }}
          </button>
          <button
            class="privacy-btn"
            data-dismiss="modal"
            type="button"
            @click="confirmClearCart()"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<script>
import MyDetail from "./partials/MyDetail";
import DeliveryAddress from "./partials/DeliveryAddress";
import Payment from "./partials/Payment";
import PickupAddress from "./partials/PickupAddress";
import RoomDelivery from "./partials/RoomDelivery";
import EatIn from "./partials/EatIn";
import DatePicker from "vuejs-datepicker";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
import { mapGetters, mapMutations } from "vuex";
import modal from "../../modal";
import GooglePay from "./partials/GooglePay";
import paymentType from "./paymentType";
import shopfooter from "./../../shared/shopfooter";
import PaymentIndicator from "../../shop/Checkout/partials/PaymentIndicator";

export default {
  components: {
    MyDetail,
    DeliveryAddress,
    Payment,
    PickupAddress,
    RoomDelivery,
    EatIn,
    DatePicker,
    modal,
    GooglePay,
    paymentType,
    shopfooter,
    PaymentIndicator,
  },
  props: {
    storeid: {
      type: String,
      default: ""
    },
    forGiftCart: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showBecomeMember: false,
      userIsExist: false,
      error: "",
      isDelivery: false,
      notes: "",
      deliveryDate: "",
      pickupDate: "",
      disabledDates: {},
      isPickup: false,
      isChargeToRoom: false,
      isEatIn: false,
      dtimes: [],
      pickupTimes: [],
      selectedDeliveryTime: "",
      selectedPickupTime: "",
      showClearCartModal: false,
      lastOrderTypeSelected: "",
      newOrderType: "",
      nextOrderType: "",
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Latitude: "",
        Longitude: ""
      },
      roomDeliveryModel: {
        RoomNumber: "",
        FirstName: "",
        LastName: "",
        Email: ""
      },
      eatInModel: {
        TableNumber: "",
        FirstName: "",
        LastName: "",
        Email: "",
        DineInField: "",
      },
      registerNew: false,
      saveCard: false,
      JoinOurMail: true,
      paymentMethod: 1,
      deliveryDisabled: false,
      pickupDisabled: false,
      userInfo: {},
      proccessing: false,
      showPaymentIndicator: false,
      paymentSucceeded: true,
      showPrivacyModal: false,
      guestUserId: null,
      googleLoaded: false,
      disableStripeBtn: false,
      stripeToken: null,
      canPayByApple: false,
      canPayByGoogle: false,
      AcceptTermsAndCondition: false,
      turnAcceptLabelToRed: false
    };
  },

  computed: {
    ...shared.computed,
    orderButtonStyles() {
      return {
        ...this.mobileStyles.btn,
        ...this.mobileStyles.mobilePlaceOrderButton
      };
    },
    totalPrice() {
      return this.getTotalPrice;
    },
    exceedMinPurchase() {
      return this.cartValue >= this.minPurchase;
    },
    showDeliveryDistance() {
      return (
        this.$route.name.toLowerCase().indexOf("checkout") >= 0 &&
        this.addressOutOfService &&
        this.deliveryAddress.StreetAddress != ""
      );
    },
    minPurchase() {
      var minPurchase = 0;
      if (this.selectedCompany) {
        if (this.selectedCompany.OrderTypeConstraintRules) {
          minPurchase = this.selectedCompany.OrderTypeConstraintRules[
            this.orderType
          ]
            ? this.selectedCompany.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
      return minPurchase;
    },
    ...mapGetters([
      "mobileStyles",
      "addressOutOfService",
      "cartValue",
      "getDeliveryAddressMessage",
      "currentStoreDoc",
      "buttonStyles",
      "getSurchargeHolidayAmount"
    ]),
    hasMarketingLicense() {
      const store = this.currentStoreDoc;

      if(store && typeof store === 'object') {
        return store.EnableLoyaltyMarketing;
      } else {
        return false;
      }
    },
  },
  watch: {
    viewConfig() {
      this.computeRules();
    },
    holder() {
      this.paymentModel.CardHolder = this.holder;
    },
    pickupDate() {
      this.pickupSurcharge();
    },
    deliveryDate() {
      this.deliverySurcharge();
    },
    dbuser() {
      this.userInfo = this.dbuser;
    },
    getDeliveryDuration() {
      this.setDeliveryTimes(this.deliveryDate);
    },
    getTotalPrice() {
      this.remountStripeButton();
    }
    // payButtonsAreDisabled(newValue) {
    //   if (newValue === false) {
    //     this.paymentMethod = this.$refs.stripePayRef.applePay ? 6 : 7;
    //     this.remountStripeButton();
    //   }
    // },
  },
  created() {
    this.setRoomNoFromStorage();
  },
  mounted() {
    shared.mounted(false, this);
  },
  beforeRouteEnter(to, from, next) {
    shared.beforeRouteEnter(to, from, next);
  },
  methods: {
    ...shared.methods,
    ...mapMutations(["setShowOverlay"]),
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    navigateToShoppingCart() {
      this.$router.push({
        name: "shoppingcartmobile",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename
        }
      });
    },
    setCanPayByApple(flag) {
      this.canPayByApple = flag;
    },
    setCanPayByGoogle(flag) {
      this.canPayByGoogle = flag;
    },
    closeClearCartModal() {
      this.$refs.ClearCartModal.hideModal();
      this.showClearCartModal = false;
      this.cancelClearCart();
    },
  },
  destroyed() {
    shared.destroyed();
  }
};
</script>
